import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Button, Modal } from 'semantic-ui-react'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { reduxForm, getFormValues, Field, SubmissionError  } from 'redux-form'
import { IconButton, Collapse, Fade, Card, CardHeader, CardContent } from '@material-ui/core'
import { ProcurementBody } from '../../../styled'
import { BottomActionsContainer } from '../styled'
import { showModal, showConfirmModal } from 'ducks/app'
import { getGlAccount, validateBudget } from 'ducks/purchaseRequisition'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { getOptionTitle } from '../../helper'
import { validation, validateCase as vCase } from 'core/validate'
import { getVendors, getPurchasingGroups, getPrSpecialOptions, getPoNumber } from 'ducks/options'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { BudgetDetailContainer, RequestInformationContainer, GeneralInfoContainer } from './styled'
import { getMappingCompanyPlants, getMappingPlantStorageLocations } from 'ducks/mappingData'
import { getGoaByCompany, getGoaItem, getProjectByCompany, getSpecialApproval, addOtherProject } from 'ducks/goa'
import { summaryDataForCheckBudget, onValidateBudgetSuccess } from '../AddItem'
import { AdditionalRemark } from '../../AttributeData'
import { purchaseOrderDetailPath } from 'routes'
import * as v from 'variables/styles'

// import r from 'reactotron-react-js'

const GeneralDetail = (props) => {
  const { 
    valueForm, handleSubmit, change, members, memberLoading,
    companyOptions, vendorOptions, vendorLoading,
    setFormStep, subCategory, mappingPurchasingGroups,
    projectOptions, projectLoading, addOtherProject,
    specialApprovalOptions, onSubmit, showConfirmModal, isDetail = false 
  } = props

  const [showReqInfo, setShowReqInfo] = useState(true)
  const [showGeneralInfo, setShowGeneralInfo] = useState(true)
  const [modal, showModal] = useState({ show: false, header: '', message: '' })

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  useEffect(() => {
    const { menuSubCategory } = valueForm

    if (props.glAccounts.length === 0 && menuSubCategory) {
        props.getGlAccount(menuSubCategory)
    } else {
      if (props.glAccounts[0].subCategoryCode !== menuSubCategory) {
        props.getGlAccount(menuSubCategory)
      }
    }
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)

    if (!props.purchasingGroupOptions.length && !props.purchasingGroupLoading) {
      props.getPurchasingGroups()
    }

    if (!props.companyPlants.length && !props.companyPlantLoading) {
      props.getMappingCompanyPlants()
    }

    if (!props.plantStorageLocations.length && !props.plantStorageLocationLoading) {
      props.getMappingPlantStorageLocations()
    }

    if (!props.prSpecial.data.length && !props.prSpecial.loading) {
      props.getPrSpecialOptions()
    }
  }, [])

  useEffect(() => {
    const { companyCode, special, goaId, projectId } = valueForm

    if (props.vendorOptions.length === 0 && !props.vendorLoading) {
      props.getVendors()
    }

    if (companyCode) {
      if (props.goa[companyCode] === undefined) {
        if (companyCode !== props.goaCompanyLoading) {
          props.getGoaByCompany(companyCode)
        } 
      }

      if (props.projects[companyCode] === undefined) {
        if (companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(companyCode)
        }
      }
    }

    if (goaId && props.goaItems[goaId] === undefined) {
      if (goaId !== props.goaItemByGoaIdLoading) {
        props.getGoaItem(goaId, 'PurchaseRequisition')
      }
    }

    if (projectId && props.specialApprovals[projectId] === undefined) {
      if (projectId !== props.specialApprovalProjectIdLoading) {
        props.getSpecialApproval(projectId)
      }
    }
  }, [valueForm.companyCode, valueForm.special, valueForm.goaId, valueForm.projectId])

  useEffect(()=>{
    if(valueForm.special){
      props.getPrSpecialOptions('Special')
    }else if(valueForm.isAffiliatedCompanies){
      props.getPrSpecialOptions('AffiliatedCompanies')
    }else if (valueForm.isPartnersPreQualified){
      props.getPrSpecialOptions('PartnersPreQualified')
    }
  },[valueForm.special, valueForm.isAffiliatedCompanies, valueForm.isPartnersPreQualified])

  const onSelectRequester = (value) => {
    if (value) {
      let member = members.find(m => m.username === value)
      if (member) {
        change('companyCode', member.companyCode)
        change('costCenterByRequester', member.costCenterCode)
        change('requesterDepartment', member.mainDepartmentEn)
      } else {
        change('companyCode', '')
        change('costCenterByRequester', '')
        change('requesterDepartment', '')
      }
    }
  }

  const beforeRequesterChange = (valueForm, setMaxStep) => (props) => {
    if (valueForm.requesterUser && valueForm.requesterUser !== props.value) {
      if (valueForm.items && valueForm.items.length) {
        props.onChange()
        let newRequester = members.find(m => m.username.toLowerCase() === props.value.toLowerCase())
        let currentRequester = companyOptions.find(m => m.value === valueForm.companyCode)
        if (newRequester.companyCode !== valueForm.companyCode) {
          showConfirmModal(
            true, 
            {
              header: `The requester's company has difference from current company.`,
              message: 
                <React.Fragment>
                  {`Do you want to change company(${currentRequester.text.replace(`${valueForm.companyCode} : `,'')}) to requester's company(${newRequester.companyEn})?`}
                  <br />
                  If you click " <b>Yes</b> "  the item details will delete immediately or " <b>No</b> " not change company.
                </React.Fragment>,
              btnConfirmText: 'Yes',
              onClickConfirm: () => {
                if (props.specialOnChange) props.specialOnChange()
                change('items', [])
                change('budgetData', { costCenter: [], wbs: [], internalOrder: [] })
                change('totalAmount', 0)
                change('vatAmount', 0)
                change('totalAmountIncludeVat', 0)
                setMaxStep(2)
              },
              btnCancelText: 'No',
            }
          )
        } else {
          let warnItems = valueForm.items.filter(i => i.accountAssignment === 'A' || i.accountAssignment === 'K' || i.accountAssignment === 'Z')
          const uniqueCostCenter = []
          warnItems.forEach(i => {
            if (uniqueCostCenter.indexOf(i.costCenter) === -1) {
              uniqueCostCenter.push(i.costCenter)
            }
          })

          let differenceCostCenter = uniqueCostCenter.filter(c => c !== newRequester.costCenterCode)

          if (differenceCostCenter.length > 0) {
            showConfirmModal(
              true, 
              {
                header: `The requester's cost center has difference from current cost center.`,
                message: 
                  <React.Fragment>
                    {`Do you want to change cost center to ${newRequester.costCenterCode}?`}
                    <br />
                    If you click " <b>Yes</b> "  the item details will delete immediately or " <b>No</b> " not to change cost center.
                  </React.Fragment>,
                btnConfirmText: 'Yes',
                onClickConfirm: () => {
                  if (props.specialOnChange) props.specialOnChange()
                  change('items', [])
                  change('budgetData', { costCenter: [], wbs: [], internalOrder: [] })
                  change('totalAmount', 0)
                  change('vatAmount', 0)
                  change('totalAmountIncludeVat', 0)
                  setMaxStep(2)
                },
                btnCancelText: 'No',
              }
            )
          } else {
            props.onChange()
            if (props.specialOnChange) props.specialOnChange()
          }
        }
      } else {
        props.onChange()
        if (props.specialOnChange) props.specialOnChange()
      }
    } else {
      props.onChange()
      if (props.specialOnChange) props.specialOnChange()
    }
  }

  const beforeCompanyChange = (valueForm, setMaxStep) => (props) => {
    if (valueForm.items && valueForm.items.length) {
      if (valueForm.companyCode && valueForm.companyCode !== props.value) {
        showConfirmModal(
          true, 
          {
            header: `The item details will delete immediately`,
            message: 
              <React.Fragment>
                {'Are you sure you want to change company '}
                <b>{getOptionTitle(companyOptions, valueForm.companyCode, false)}</b> to <b>{getOptionTitle(companyOptions, props.value, false)}</b>?
              </React.Fragment>,
            btnConfirmText: 'Yes',
            onClickConfirm: () => {
              props.onChange()
              if (props.specialOnChange) props.specialOnChange()
              change('items', [])
              change('budgetData', { costCenter: [], wbs: [], internalOrder: [] })
              change('totalAmount', 0)
              change('vatAmount', 0)
              change('totalAmountIncludeVat', 0)
              setMaxStep(2)
            },
            btnCancelText: 'No',
            onClickCancel: () => { 
              props.clearSearchText()
            }
          }
        )
      } else {
        props.onChange()
        if (props.specialOnChange) props.specialOnChange()
      }
    } else {
      props.onChange()
      if (props.specialOnChange) props.specialOnChange()
    }
  }

  const onSubmitForm = (value) => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(10).then(() => {
      let { companyCode } = valueForm

      if (subCategory.goaItemCode === undefined ||subCategory.goaItemCode === null || subCategory.goaItemCode === '') {
        if (subCategory.goaItemCodes[companyCode]) {
          change('goaItemCode', subCategory.goaItemCodes[companyCode])
        } else if (subCategory.goaItemCodes['all']) {
          change('goaItemCode', subCategory.goaItemCodes['all'])
        }
      }

      if (subCategory.prType === undefined ||subCategory.prType === null || subCategory.prType === '') {
        if (subCategory.prTypes[companyCode]) {
          change('type', subCategory.prTypes[companyCode])
        } else if (subCategory.prTypes['all']) {
          change('type', subCategory.prTypes['all'])
        }
      }

      let defaultPurchasingGroup = ''
      let purchasingGroupByCompany = mappingPurchasingGroups.find(m => m.companyCode === valueForm.companyCode)
      if (subCategory.purchasingGroup) {
        if (subCategory.purchasingGroup[companyCode]) {
          if (subCategory.purchasingGroup[companyCode].length === 1) {
            defaultPurchasingGroup = subCategory.purchasingGroup[companyCode][0]
          } else {
            if (purchasingGroupByCompany) {
              subCategory.purchasingGroup[companyCode].forEach(p => {
                let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
                if (match) {
                  defaultPurchasingGroup = match
                }
              })
            }
          }
        } else {
          if (subCategory.purchasingGroup.all) {
            if(subCategory.purchasingGroup.all.length === 1) {
              defaultPurchasingGroup = subCategory.purchasingGroup.all[0]
            } else {
              if (purchasingGroupByCompany) {
                subCategory.purchasingGroup.all.forEach(p => {
                  let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
                  if (match) {
                    defaultPurchasingGroup = match
                  }
                })
              }
            }
          }else{
            for(let i=0;i<=9;i++){
              if(defaultPurchasingGroup) break
              let samplePlant = `${companyCode}${i}`;
              if (subCategory.purchasingGroup[samplePlant]) {
                if (subCategory.purchasingGroup[samplePlant].length === 1) {
                  defaultPurchasingGroup = subCategory.purchasingGroup[samplePlant][0]
                } else {
                  if (purchasingGroupByCompany) {
                    subCategory.purchasingGroup[samplePlant].forEach(p => {
                      let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
                      if (match) {
                        defaultPurchasingGroup = match
                      }
                    })
                  }
                }
              }
            }
          }
        }
      }
      
      if (defaultPurchasingGroup) {
        onSubmit(value)
      } else {
        showModal(true, 'Error', `Can't create purchase requisition category under company ${companyCode} \r\n
          (Because : Purchasing Group not support, Please contact admin.)`)
        throw new SubmissionError('error.validationErrors')
      }
    })
  }

  const onChangeDocumentDate = (newValue, oldValue) => {
    const { validateBudget, costCenterOptions, glAccountOptions, wbsOptions, orderOptions } = props

    if (newValue && oldValue && newValue.getFullYear() !== oldValue.getFullYear()) {
      if (valueForm && valueForm.items && valueForm.items.length > 0) {
        var rawData = summaryDataForCheckBudget({ ...valueForm, documentDate: newValue })
        validateBudget(rawData, onValidateBudgetSuccess({newRawData: rawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions}))
      }
    }
  }

  const getSpecialReasonOption = (specialReason) => {
    return props.prSpecial.data.find(x => x.value === (specialReason || valueForm.specialReason || ''))
  }

  const getVendorOptions = (specialReason, subReason) => {
    var reason = getSpecialReasonOption(specialReason)
    var vendorCondition = null
    if (reason) {
      if ((subReason || valueForm.subSpecialReason)) {
        var subReasonOpt = (reason.subOptions || []).find(x => x.value === ((subReason || valueForm.subSpecialReason)))
        if (subReasonOpt) {
          vendorCondition = subReasonOpt.vendorCondition
        }
      } else {
        vendorCondition = reason.vendorCondition
      }
    }

    // r.log({ reason, vendorCondition })

    if (vendorCondition) {
      const { checkCase, positiveCheck, condition, vendorCodes } = vendorCondition
      if (checkCase === 'specific') {
        return vendorOptions.filter(v => (vendorCodes || []).includes(v.value)) || []
      } else if (checkCase === 'startsWith') {
        var conditions = condition.split('|') || []
        var vendorOpts = []

        conditions.forEach((c) => {
          vendorOpts = [
            ...vendorOpts,
            ...(vendorOptions.filter(v => v.value.startsWith(c) === positiveCheck) || [])
          ]
        })

        return vendorOpts
      }
    }
    
    return vendorOptions
  }

  const getVendorOptionsNonSpecial = (reason) => {
    var reasonItem = getSpecialReasonOption(reason)
    var vendorCondition = null
    if(reasonItem){
      var vendorCondition = reasonItem.vendorCondition
    }

    // r.log({ reason, vendorCondition })

    if (vendorCondition) {
      const { checkCase, positiveCheck, condition, vendorCodes } = vendorCondition
      if (checkCase === 'specific') {
        return vendorOptions.filter(v => (vendorCodes || []).includes(v.value)) || []
      } else if (checkCase === 'startsWith') {
        var conditions = condition.split('|') || []
        var vendorOpts = []

        conditions.forEach((c) => {
          vendorOpts = [
            ...vendorOpts,
            ...(vendorOptions.filter(v => v.value.startsWith(c) === positiveCheck) || [])
          ]
        })

        return vendorOpts
      }
    }
    
    return vendorOptions
  }
 
  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <BudgetDetailContainer>
          <form onSubmit={handleSubmit((value) => onSubmitForm(value))}>
            <Card>
              <CardHeader 
                title='Request Information'
                action={
                  <IconButton aria-label='Expand' onClick={() => setShowReqInfo(!showReqInfo) }>
                    {showReqInfo ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                }
              />
              <Collapse in={showReqInfo}>
                <CardContent>
                  <RequestInformationContainer>
                    <div className='rowFields'>
                      <Field name='title' label='Title (Request for)' require type={type.text} component={FieldInput} maxLength={200} maxLengthMessage='Title must be less than or equal to 200 characters' />
                    </div>
                    <div className='rowFields'>
                      <Field name='remark' label='Remark' type={type.textArea} component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='requesterUser' 
                        label='Requester' 
                        require 
                        loading={memberLoading}
                        options={memberOptions} 
                        type={type.select}
                        beforeOnChange={beforeRequesterChange(valueForm, props.setMaxStep)}
                        specialOnChange={onSelectRequester} 
                        component={FieldInput} />
                      <Field 
                        name='companyCode' 
                        label='Company'
                        require 
                        type={type.select} 
                        beforeOnChange={beforeCompanyChange(valueForm, props.setMaxStep)}
                        specialOnChange={(value) => {
                          change('projectId', '')
                          change('specialApprovalId', '')
                          let member = members.find(m => lower(m.username) === valueForm.requesterUser)
                          if (member) {
                            if (member.companyCode !== value) {
                              change('costCenterByRequester', '')
                            }
                          }

                          if (valueForm.isAdditional) {
                            if (props.poNumbers.companyCode !== value) {
                              props.getPoNumber(value, () => { change('referencePoNo', '') })
                            } else {
                              if (props.poNumbers.data.length === 0 && props.poNumbers.loading === false) {
                                props.getPoNumber(value, () => { change('referencePoNo', '') })
                              }
                            }
                          }
                        }}
                        options={companyOptions} 
                        component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='projectId' 
                        label='Project Name' 
                        allowAdditions
                        editable
                        require
                        loading={projectLoading} 
                        options={projectOptions} 
                        type={type.select}
                        onAddNewItem={addOtherProject}
                        specialOnChange={() => change('specialApprovalId', '')}
                        component={FieldInput} />
                      {specialApprovalOptions.length > 0 ? 
                        <Field name='specialApprovalId' label='Special Approval' editable options={specialApprovalOptions} type={type.select} component={FieldInput} /> : 
                        <Field name='empty' type={type.empty} component={FieldInput} />
                      }
                    </div>
                    <div className='rowFields'>
                      <Field name='requesterDepartment' disable label='Department' editable={false} type={type.text} component={FieldInput} />
                      <Field 
                        name='documentDate' 
                        label='Document Date' 
                        type={type.date} 
                        require 
                        component={FieldInput}
                        specialOnChange={onChangeDocumentDate}
                      />
                    </div>
                  </RequestInformationContainer>
                </CardContent>
              </Collapse>
            </Card>
            <Card style={{ marginTop: '10px' }}>
              <CardHeader 
                title='Type of Procurement '
                action={
                  <IconButton aria-label='Expand' onClick={() => setShowGeneralInfo(!showGeneralInfo) }>
                    {showReqInfo ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                }
              />
              <Collapse in={showGeneralInfo}>
                <CardContent>
                  <GeneralInfoContainer>
                    <div className='rowFields'>
                      <Field 
                        name='priority' 
                        label='Priority' 
                        className='halfRow'
                        options={[
                          { title: 'Normal', value: 'normal', color: 'blue' },
                          { title: 'Urgent', value: 'urgent', color: 'red' },
                        ]} 
                        type={type.tabSelection} 
                        component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='special' 
                        label='Special PR' 
                        type={type.switch}
                        specialOnChange={(value) => {
                          if (value === true) {
                            // clear Additional
                            change('isAdditional', false)
                            change('additionalReason', '')
                            change('referencePoNo', '')
                            change('referenceContractNo', '')
                            // clear Affiliated
                            change('isAffiliatedCompanies', '')
                            change('affiliatedCompaniesReason', '')
                            change('vendorCode', '')
                            //clear PartnersPreQualified
                            change('isPartnersPreQualified', '')
                            change('partnersPreQualifiedReason', '')
                            change('vendorCode', '')
                          } else {
                            change('specialReason', '')
                            change('subSpecialReason', '')
                            change('vendorCode', '')
                          }
                        }} 
                        component={FieldInput} />
                    </div>
                    <Collapse in={valueForm && valueForm.special} timeout={500}>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='specialReason' 
                          label='Reason' 
                          type={type.radio}
                          options={props.prSpecial.data} 
                          specialOnChange={(value) => {
                            change('subSpecialReason', '')

                            var vOpt = getVendorOptions(value, '')
                            if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                              change('vendorCode', '')
                            }
                          }}
                          component={FieldInput} 
                        />
                      </div>
                      {
                        valueForm.specialReason === 'SP04' ?
                          <div className='rowFields'>
                            <Field 
                              require 
                              name='subSpecialReason' 
                              // label='Reason' 
                              type={type.select}
                              options={(getSpecialReasonOption() || {}).subOptions || []}
                              specialOnChange={(value) => {                                
                                var vOpt = getVendorOptions(valueForm.specialReason, value)
                                if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                                  change('vendorCode', '')
                                }
                              }}
                              placeHolder='กรุณาเลือก' 
                              component={FieldInput} 
                            />
                          </div> : null
                      }
                      {/* <div className='rowFields'>
                        <Field name='specialTitle' require label='Special PR Title' type={type.text} component={FieldInput} />
                      </div>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='specialReason' 
                          label='Special PR Reason' 
                          placeHolder='ระบุเหตุผลที่เลือก Vendor มีคุณสมบัติเฉพาะเจาะจงอย่างไร เช่น เป็นรายเดียวสามารถส่งมอบสินค้าหรือบริการนั้นได้ และตรงกับความต้องการ'
                          type={type.textArea} 
                          component={FieldInput} />
                      </div> */}
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='vendorCode' 
                          label='Vendor' 
                          options={getVendorOptions()} 
                          loading={vendorLoading} 
                          editable 
                          placeHolder='กรุณาระบุชื่อ Vendor ที่ต้องการจัดจ้างพิเศษ' 
                          type={type.select} 
                          component={FieldInput} 
                        />
                      </div>
                    </Collapse>
                    <div className='rowFields'>
                      <Field 
                        name='isAffiliatedCompanies' 
                        label='Affiliated Companies' 
                        type={type.switch}
                        specialOnChange={(value) => {
                          if (value === true) {
                            // clear Additional
                            change('isAdditional', false)
                            change('additionalReason', '')
                            change('referencePoNo', '')
                            change('referenceContractNo', '')
                            // clear special
                            change('special', '')
                            change('specialReason', '')
                            change('subSpecialReason', '')
                            //clear PartnersPreQualified
                            change('isPartnersPreQualified', '')
                            change('partnersPreQualifiedReason', '')
                            change('vendorCode', '')

                            //set defaule affiliatedCompaniesReason
                            change('affiliatedCompaniesReason','AF01')
                          } else {
                            // clear my self
                            change('isAffiliatedCompanies', '')
                            change('affiliatedCompaniesReason', '')
                            change('vendorCode', '')
                          }
                        }} 
                        component={FieldInput} />
                    </div>
                    <Collapse in={valueForm && valueForm.isAffiliatedCompanies} timeout={500}>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='affiliatedCompaniesReason' 
                          label='Reason' 
                          type={type.radio}
                          options={props.prSpecial.data} 
                          specialOnChange={(value) => {
                            var vOpt = getVendorOptionsNonSpecial(value)
                            if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                              change('vendorCode', '')
                            }
                          }}
                          component={FieldInput} 
                        />
                      </div>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='vendorCode' 
                          label='Vendor' 
                          options={getVendorOptionsNonSpecial(valueForm.affiliatedCompaniesReason)} 
                          loading={vendorLoading} 
                          editable 
                          placeHolder='กรุณาระบุชื่อ Vendor ที่ต้องการจัดจ้างพิเศษ' 
                          type={type.select} 
                          component={FieldInput} 
                        />
                      </div>
                    </Collapse>
                    <div className='rowFields'>
                      <Field 
                        name='isPartnersPreQualified' 
                        label='Partners(Pre-Qualified)' 
                        type={type.switch}
                        specialOnChange={(value) => {
                          if (value === true) {
                            // clear Additional
                            change('isAdditional', false)
                            change('additionalReason', '')
                            change('referencePoNo', '')
                            change('referenceContractNo', '')
                            // clear special
                            change('special', '')
                            change('specialReason', '')
                            change('subSpecialReason', '')
                            //clear Affiliated
                            change('isAffiliatedCompanies', '')
                            change('affiliatedCompaniesReason', '')
                            change('vendorCode', '')
                          } else {
                            // clear my self
                            change('isPartnersPreQualified', '')
                            change('partnersPreQualifiedReason', '')
                            change('vendorCode', '')
                          }
                        }} 
                        component={FieldInput} />
                    </div>
                    <Collapse in={valueForm && valueForm.isPartnersPreQualified} timeout={500}>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='partnersPreQualifiedReason' 
                          label='Reason' 
                          type={type.radio}
                          options={props.prSpecial.data} 
                          specialOnChange={(value) => {
                            var vOpt = getVendorOptionsNonSpecial(value)
                            if (vOpt.find(x => x.value === valueForm.vendorCode) === null) {
                              change('vendorCode', '')
                            }
                          }}
                          component={FieldInput} 
                        />
                      </div>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='vendorCode' 
                          label='Vendor' 
                          options={getVendorOptionsNonSpecial(valueForm.partnersPreQualifiedReason)} 
                          loading={vendorLoading} 
                          editable 
                          placeHolder='กรุณาระบุชื่อ Vendor ที่ต้องการจัดจ้างพิเศษ' 
                          type={type.select} 
                          component={FieldInput} 
                        />
                      </div>
                    </Collapse>
                    <div className='rowFields'>
                      <Field 
                        name='isAdditional' 
                        label='Additional PR' 
                        type={type.switch}
                        specialOnChange={(value) => {
                          if (value === true) {
                            // clear Special
                            change('special', false)
                            change('specialReason', '')
                            change('subSpecialReason', '')
                            change('vendorCode', '')

                            if (props.poNumbers.companyCode !== valueForm.companyCode) {
                              props.getPoNumber(valueForm.companyCode, () => { change('referencePoNo', '') })
                            } else {
                              if (props.poNumbers.data.length === 0 && props.poNumbers.loading === false) {
                                props.getPoNumber(valueForm.companyCode, () => { change('referencePoNo', '') })
                              }
                            }

                            // clear Affiliated
                            change('isAffiliatedCompanies', '')
                            change('affiliatedCompaniesReason', '')
                            change('vendorCode', '')
                            //clear PartnersPreQualified
                            change('isPartnersPreQualified', '')
                            change('partnersPreQualifiedReason', '')
                            change('vendorCode', '')
                          } else {
                            change('additionalReason', '')
                            change('referencePoNo', '')
                            change('referenceContractNo', '')
                          }
                        }} 
                        component={FieldInput} />
                    </div>
                    <Collapse in={valueForm && valueForm.isAdditional} timeout={500}>
                      {AdditionalRemark()}
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='additionalReason' 
                          label='Additional Detail'
                          placeHolder='ระบุรายละเอียดเพิ่มเติมของงานเพิ่ม' 
                          type={type.textArea} 
                          component={FieldInput} />
                      </div>
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='referencePoNo' 
                          label='Reference SAP PO (Original) No' 
                          placeHolder=''
                          options={props.poNumbers.data}
                          loading={props.poNumbers.loading}
                          type={type.select} 
                          specialOnChange={(value) => {
                            var po = props.poNumbers.data.find(x => x.value === value)
                            if (po !== null) {
                              change('referencePoId', po.poId)
                            }
                          }}
                          component={FieldInput} />
                        <Field 
                          name='referenceContractNo' 
                          label='Reference Contract No' 
                          type={type.text} 
                          component={FieldInput} />
                      </div>
                      {
                        valueForm.isAdditional && valueForm.referencePoId ?
                          <div className='rowFields'>
                            <a 
                              href={purchaseOrderDetailPath(valueForm.referencePoId)} 
                              target='_blank'
                              style={{
                                color: v.ezMainColor,
                                fontWeight: 'bold',
                                textDecoration: 'underline'
                              }}
                            >PO Detail</a>
                          </div> : null
                      }
                    </Collapse>
                    {
                      subCategory.isRent ? 
                      <div className='rowFields'>
                        <Field 
                          require 
                          name='rentDays' 
                          label='Rent (days)' 
                          className='halfRow'
                          type={type.text} 
                          component={FieldInput} />
                      </div> : null
                    }
                  </GeneralInfoContainer>
                </CardContent>
              </Collapse>
            </Card>
            <BottomActionsContainer>
              <Button 
                type='button'
                content='Back'
                icon='arrow left' 
                labelPosition='left'
                color='red'
                onClick={() => setFormStep(1)} 
              /> 
              <Button 
                type='submit'
                content='Next' 
                color='blue' 
                icon='arrow right' 
                labelPosition='right'
              />
            </BottomActionsContainer>
          </form>
        </BudgetDetailContainer>
        <Modal open={modal.show}>
          <Modal.Header>{modal.header}</Modal.Header>
          <Modal.Content>{modal.message}</Modal.Content>
          <Modal.Actions>
            <Button 
              icon='delete'
              color='red' 
              labelPosition='left' 
              content='Close'
              onClick={() => showModal(false, '', '')}/>
          </Modal.Actions>
        </Modal>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formCreatePR')(state) || {}
  let subCategory = state.pr.subCategory

  const user = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  if (!valueForm.requesterUser && user) {
    valueForm.requesterUser = lower(user)
  }

  const members = state.member.members
  let defaultCompany = ''
  let defaultDepartment = ''
  let costCenter = ''
  if ((valueForm.requesterUser && !(valueForm.companyCode)) && members.length > 0) {
    let member = members.find(m => lower(m.username) === valueForm.requesterUser)
    if (member) {
      defaultCompany = member.companyCode || ''
      defaultDepartment = member.mainDepartmentEn || ''
      costCenter = member.costCenterCode || ''
    }
  }

  const defaultGoaItemCode = subCategory && subCategory.goaItemCode ? subCategory.goaItemCode : ''

  let goaOptions = []
  let defaultGoa = 0
  if (valueForm.companyCode && state.goa.goa && state.goa.goa[valueForm.companyCode]) {
    goaOptions = state.goa.goa[valueForm.companyCode].map(goa => { 
      if (goa.defaultWithCompany) { defaultGoa = goa.id }
      return { value: goa.id, text: goa.name } 
    })

    if (defaultGoa === 0 && goaOptions.length === 1) {
      defaultGoa = goaOptions[0].value
    }

    if (valueForm.goaId && valueForm.goaId !== defaultGoa) {
      valueForm.goaId = defaultGoa
    }
  }

  let projectOptions = []
  if (valueForm.companyCode && state.goa.projects && state.goa.projects[valueForm.companyCode]) {
    projectOptions = state.goa.projects[valueForm.companyCode].map(p => { 
      return { value: p.id, text: p.projectName } 
    })

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach(p => { 
        projectOptions.push({ value: p.id, text: p.projectName })
      })
    }
  }

  let specialApprovalOptions = []
  if (valueForm.projectId && state.goa.specialApprovals && state.goa.specialApprovals[valueForm.projectId]) {
    specialApprovalOptions = state.goa.specialApprovals[valueForm.projectId].map(s => { 
      return { value: s.id, text: s.name } 
    })
  }

  const orderOptions = state.options.orders.data.map(o => ({
    ...o,
    text: o.text.removeLeadingZero(),
  }))

  return ({
    initialValues: {
      ...valueForm,
      menuCategory: valueForm.menuCategory ? valueForm.menuCategory : '',
      menuSubCategory: valueForm.menuSubCategory ? valueForm.menuSubCategory : '',
      items: valueForm.items ? valueForm.items : [],
      title: valueForm.title ? valueForm.title : '',
      requesterUser: valueForm.requesterUser ? valueForm.requesterUser : '',
      companyCode: valueForm.companyCode || defaultCompany,
      goaId: valueForm.goaId ? valueForm.goaId : defaultGoa,
      goaItemCode: valueForm.goaItemCode ? valueForm.goaItemCode : defaultGoaItemCode,
      specialApprovalId: valueForm.specialApprovalId ? valueForm.specialApprovalId : '',
      documentDate:  valueForm.documentDate ? valueForm.documentDate : new Date(),
      type: subCategory ? subCategory.prType : '',
      category: subCategory ? subCategory.prCategory : '',
      isAsset: subCategory ? subCategory.isAsset : false,
      isIt: subCategory ? subCategory.isIt : false,
      priority: valueForm.priority ? valueForm.priority : 'normal',
      special: valueForm.special ? valueForm.special : false,
      vendor: valueForm.vendorCode ? valueForm.vendorCode : '',
      specialTitle: valueForm.specialTitle ? valueForm.specialTitle : '',
      specialReason: valueForm.specialReason ? valueForm.specialReason : '',
      createdByUser: valueForm.createdByUser ? valueForm.createdByUser : user,
      modifiedByUser: valueForm.modifiedByUser ? valueForm.modifiedByUser : user,
      requesterDepartment: valueForm.requesterDepartment || defaultDepartment,
      costCenterByRequester: valueForm.costCenterByRequester || costCenter,
      isRent: subCategory.isRent,
    },
    valueForm,
    subCategory,
    companyOptions: state.options.companies.data,
    vendorLoading: state.options.vendors.loading,
    vendorOptions: state.options.vendors.data,
    prCategoryOptions: state.options.prCategories.data,
    memberLoading: state.member.memberLoading,
    members: state.member.members,
    costCenterOptions: state.options.costCenters.data,
    glAccountOptions: state.options.glAccounts.data,
    wbsOptions: state.options.wbsElements.data,
    orderOptions,
    projectOptions,
    specialApprovalOptions,
    defaultGoa,
    glAccounts: state.pr.glAccounts,
    glLoading: state.pr.glLoading,
    goa: state.goa.goa,
    goaCompanyLoading: state.goa.goaCompanyLoading,
    goaLoading: state.goa.goaLoading,
    goaItems: state.goa.goaItems,
    goaItemByGoaIdLoading: state.goa.goaItemByGoaIdLoading,
    goaItemLoading: state.goa.goaItemLoading,
    projects: state.goa.projects,
    projectCompanyLoading: state.goa.projectCompanyLoading,
    projectLoading: state.goa.projectLoading,
    specialApprovals: state.goa.specialApprovals,
    specialApprovalProjectIdLoading: state.goa.specialApprovalProjectIdLoading,
    specialApprovalLoading: state.goa.specialApprovalLoading,
    purchasingGroupLoading: state.options.purchasingGroups.loading,
    purchasingGroupOptions: state.options.purchasingGroups.data,
    mappingPurchasingGroups: state.mappingData.purchasingGroups.data,
    companyPlants: state.mappingData.companyPlants.data,
    companyPlantLoading: state.mappingData.companyPlants.loading,
    plantStorageLocations: state.mappingData.plantStorageLocations.data,
    plantStorageLocationLoading: state.mappingData.plantStorageLocations.loading,
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
    prSpecial: state.options.prSpecial,
    poNumbers: state.options.poNumbers,
  })
}

const mapDispatchToProps = {
  getVendors,
  getHrmsMembers,
  getGoaByCompany,
  getGoaItem,
  getGlAccount,
  getProjectByCompany,
  addOtherProject,
  getSpecialApproval,
  getPurchasingGroups,
  showModal,
  showConfirmModal,
  getMappingCompanyPlants, 
  getMappingPlantStorageLocations,
  validateBudget,
  getPrSpecialOptions,
  getPoNumber,
  getAllMembers
}

const validate = values => {
  let errors = {}
  errors = validation(values, 'title', [vCase.require, vCase.maxLength200], errors)
  errors = validation(values, 'company', [vCase.require], errors)
  errors = validation(values, 'requester', [vCase.require], errors)
  errors = validation(values, 'documentDate', [vCase.require], errors)
  errors = validation(values, 'projectId', [vCase.require], errors)
  
  if (values.special) {
    errors = validation(values, 'specialReason', [vCase.require], errors)

    if (values.specialReason === 'SP04') {
      errors = validation(values, 'subSpecialReason', [vCase.require], errors)
    }

    errors = validation(values, 'vendorCode', [vCase.require], errors)
  }

  if (values.isAdditional) {
    errors = validation(values, 'additionalReason', [vCase.require], errors)
    errors = validation(values, 'referencePoNo', [vCase.require, vCase.maxLength10], errors)
  }

  if (values.isAffiliatedCompanies) {
    errors = validation(values, 'affiliatedCompaniesReason', [vCase.require], errors)
    errors = validation(values, 'vendorCode', [vCase.require], errors)
  }

  if (values.isPartnersPreQualified) {
    errors = validation(values, 'partnersPreQualifiedReason', [vCase.require], errors)
    errors = validation(values, 'vendorCode', [vCase.require], errors)
  }

  if (values.isRent) {
    errors = validation(values, 'rentDays', [vCase.require, vCase.positiveInteger], errors)
  }

  return errors
}

const GeneralDetailForm = reduxForm({
  form: 'formCreatePR',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: scrollToFirstValidateFailElement
})(GeneralDetail)

export default connect(mapStateToProps, mapDispatchToProps)(GeneralDetailForm)
